export default __webpack_public_path__ + "static/media/posture_murai.6ba9fd85.png";